import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// ==========================================================
// Component ฉลากสติ๊กเกอร์วัสดุสิ้นเปลือง (แบบเต็ม - Consumable Full Label)
// Layout: 200px x 400px (Rotated 90deg สำหรับเครื่องพิมพ์สติ๊กเกอร์ความร้อน Thermal)
// ==========================================================
const ConsumableFullLabel = React.forwardRef(({ data = {}, previewMode = false }, ref) => {
  const qrValue = data.qr_code || data.id || '';
  const specialtyLabel = data.specialty || 'ทันตกรรมทั่วไป';
  const formattedPrice = data.unit_price != null && data.unit_price !== ''
    ? `฿${Number(data.unit_price).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : '-';

  return (
    <div
      ref={ref}
      style={{
        width: '200px',
        height: '400px',
        backgroundColor: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
        border: previewMode ? '2px solid #cbd5e1' : 'none',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          width: '400px',
          height: '200px',
          position: 'absolute',
          top: 0,
          left: '200px',
          transformOrigin: '0 0',
          transform: 'rotate(90deg)',
          display: 'flex',
          flexDirection: 'column',
          padding: '8px 12px',
          boxSizing: 'border-box',
          fontFamily: "'Sarabun', 'Segoe UI', -apple-system, sans-serif",
          color: '#000000'
        }}
      >
        {/* แถบหัวเรื่องทึบสีดำ สไตล์ Inverted Solid Black Banner */}
        <div
          style={{
            backgroundColor: '#000000',
            color: '#ffffff',
            fontSize: '14px',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '3px 6px',
            borderRadius: '3px',
            letterSpacing: '0.5px',
            marginBottom: '6px',
            lineHeight: 1.2
          }}
        >
          ■ วัสดุสิ้นเปลือง: {specialtyLabel} ■
        </div>

        {/* ส่วนเนื้อหารายละเอียด และ QR Code */}
        <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '8px' }}>
          {/* ฝั่งซ้าย: ข้อมูลสินค้า */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              maxWidth: '245px',
              gap: '3px'
            }}
          >
            {/* ชื่อรายการ (ตัวหนา ขนาดใหญ่) */}
            <div
              style={{
                fontSize: '22px',
                fontWeight: '900',
                lineHeight: '1.2',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
              title={data.item_name || '-'}
            >
              {data.item_name || '-'}
            </div>

            {/* ข้อมูล Lot & วันหมดอายุ */}
            <div style={{ fontSize: '15px', fontWeight: 'bold', lineHeight: '1.3' }}>
              <div>LOT: {data.lot_number || '-'}</div>
              <div>
                EXP:{' '}
                <span style={{ color: previewMode && data.exp_date ? '#d97706' : '#000000' }}>
                  {data.exp_date || '-'}
                </span>
              </div>
            </div>

            {/* ราคา, ผู้รับผิดชอบ และเลขที่ใบเสร็จ */}
            <div style={{ fontSize: '13px', lineHeight: '1.35', fontWeight: '600', color: '#111827' }}>
              <div>
                ราคา/หน่วย: <strong>{formattedPrice}</strong>
                {data.unit ? ` / ${data.unit}` : ''}
              </div>
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                ผู้รับผิดชอบ: {data.caretaker_name || '-'}
              </div>
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '12px', color: '#374151' }}>
                {data.receipt_number ? `ใบเสร็จ: #${data.receipt_number}` : ''}
                {data.po_number ? ` | PO: ${data.po_number}` : ''}
              </div>
            </div>
          </div>

          {/* ฝั่งขวา: QR Code & รหัส Monospace */}
          <div
            style={{
              width: '135px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div
              style={{
                border: '2px dashed #000000',
                borderRadius: '4px',
                padding: '4px',
                backgroundColor: '#ffffff',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <QRCodeCanvas
                value={qrValue || 'CON-EMPTY'}
                size={96}
                level="M"
                style={{ width: '96px', height: '96px', display: 'block' }}
              />
            </div>
            <div
              style={{
                fontSize: '11px',
                marginTop: '4px',
                fontFamily: 'monospace',
                textAlign: 'center',
                fontWeight: 'bold',
                letterSpacing: '0.3px',
                wordBreak: 'break-all'
              }}
            >
              {qrValue || '-'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ConsumableFullLabel;
